type DevAuthEnv = Record<string, string | boolean | undefined>

function currentEnv() {
  return (globalThis as { importMeta?: { env?: DevAuthEnv } }).importMeta?.env ?? (import.meta as ImportMeta & { env?: DevAuthEnv }).env ?? {}
}

export function localDevAuthBypass(env: DevAuthEnv = currentEnv()) {
  return localDevRuntimeBypass(env) && env.VITE_REQUIRE_AUTH !== "1"
}

export function localDevRuntimeBypass(env: DevAuthEnv = currentEnv()) {
  return ["1", "true"].includes(String(env.DEV))
}
